import * as React from 'react';
import { useEffect, useState } from 'react';

import { api } from '@api/reduxApi';
import { Input, Text } from '@components/common';
import { Tooltip } from '@components/Tooltip';

import { useBulkUploadActions } from '../../../context';

import { CellFC } from './types';

const NO_TITLE = 'Set title…';

export const Name: CellFC = ({ row, tabIndex }) => {
  const title = row.original.type === 'repoFile' ? row.original.file.name : row.original.session.title;

  const [value, setValue] = useState(title);
  const [editing, setEditing] = useState(false);

  const [updateRepoSession, { isLoading: isUpdatingRepoSession, isSuccess: isUpdatingRepoSessionSuccess }] =
    api.useUpdateRepoSessionMutation();

  const [updateInsight, { isLoading: isUpdatingInsight, isSuccess: isUpdatingInsightSuccess }] =
    api.useUpdateInsightMutation();

  const { setItem } = useBulkUploadActions();

  const handleBlur = () => {
    const newItem = {
      ...row.original,
      ...(row.original.type === 'repoFile'
        ? { insight: { ...(row.original as RepoFileItem).insight, title: value } }
        : { session: { ...(row.original as RecordingItem | ZoomItem).session, title: value } })
    };

    if (row.original.type === 'repoFile' && row.original.insight?.slug) {
      setItem(newItem as RepoFileItem);

      updateInsight({ slug: row.original.insight.slug, title: value });
      return;
    }

    setItem(newItem as RecordingItem | ZoomItem);

    updateRepoSession({ uuid: (row.original as RecordingItem | ZoomItem).session.uuid, title: value });
  };

  const handleClick = () => {
    setEditing(true);
  };

  useEffect(() => {
    if (editing && (isUpdatingRepoSessionSuccess || isUpdatingInsightSuccess)) {
      setEditing(false);
    }
  }, [isUpdatingRepoSessionSuccess, isUpdatingInsightSuccess]);

  if (row.original.type === 'repoFile' && row.original.status !== 'done') {
    return (
      <Tooltip content='The title of the PDF Insight may be changed when the upload is complete.'>
        <Text className='w-40 cursor-text truncate px-3 py-2' color='gray-500'>
          {value || NO_TITLE}
        </Text>
      </Tooltip>
    );
  }

  if (editing) {
    return (
      <Input
        autoFocus
        className='h-10 w-40 truncate'
        textSize='base'
        disabled={isUpdatingRepoSession || isUpdatingInsight}
        value={value}
        name='title'
        onChange={setValue}
        onBlur={handleBlur}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.currentTarget.blur();
          }
        }}
        tabIndex={tabIndex}
      />
    );
  }

  return (
    <Text
      tabIndex={tabIndex}
      className='w-40 cursor-text truncate px-3 py-2'
      color={value ? undefined : 'gray-500'}
      onClick={handleClick}
      onFocus={handleClick}
    >
      {value || NO_TITLE}
    </Text>
  );
};
